import Routes from 'Routes'
import { AuthProvider, AuthState, reducer } from 'context/AppContext'
import React from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { appEnvironment, pixelKey } from 'configs'
// import DevBanner from './components/general/DevBanner'

const App = () => (
  <Container>
    {/* <DevBanner /> */}
    <Helmet>
      <title>Focal</title>
      <meta name="description" content="Marketplace for photographers" />
      <script>
        {appEnvironment === 'production'
          ? `!(function (f, b, e, v, n, t, s) {
          if (f.fbq) return
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          }
          if (!f._fbq) f._fbq = n
          n.push = n
          n.loaded = !0
          n.version = '2.0'
          n.queue = []
          t = b.createElement(e)
          t.async = !0
          t.src = v
          s = b.getElementsByTagName(e)[0]
          s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
        fbq('init', '${pixelKey}')
        fbq('track', 'PageView')`
          : null}
      </script>
      <noscript>
        {appEnvironment === 'production'
          ? `<img
            height="1"
            width="1"
            style="display: none"
            src=https://www.facebook.com/tr?id=${pixelKey}&ev=PageView&noscript=1
          />`
          : null}
      </noscript>
    </Helmet>
    <AuthProvider initialState={AuthState()} reducer={reducer}>
      <Routes />
    </AuthProvider>
  </Container>
)

export default App

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
`

/*
 * Design tokens moved to src/styles/tokens.css.
 *
 * They used to live here in a createGlobalStyle block, which styled-components
 * injects at runtime - so default.css (plain CSS, parsed earlier) could resolve
 * `var(--focus-ring)` as unset on first paint. As a stylesheet imported ahead of
 * default.css in index.js they are available immediately. Values are unchanged.
 */

Container.displayName = 'AppRoot'
